<template>
  <v-tabs v-if="elements && elements.length" show-arrows v-model="activeTab" grow>
    <v-tabs-slider></v-tabs-slider>
    <v-tab v-for="(element, index) in elements" :key="index">
      <div>
        Matrice
        <matrix-status-badge :index="index"></matrix-status-badge>
      </div>
    </v-tab>

    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="(element, index) in elements" :key="index">
        <control-tab-content :index="index" />
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script lang="ts">
import Vue from 'vue';
import ControlTabContent from '@/components/control-report/control-tab-content.vue';
import MatrixStatusBadge from '@/components/matrix-status-badge.vue';
import { matrix, MatrixElement } from '@/modules/matrix';

export default Vue.extend({
  components: {
    ControlTabContent,
    MatrixStatusBadge
  },
  data() {
    return {
      activeTab: null
    };
  },
  computed: {
    elements(): MatrixElement[] {
      return matrix.elements;
    }
  }
});
</script>
